import {useQuoteField} from 'Quoting/components/hooks/useHandleQuoteFieldChange';
import {FormRowGrid, GridRowProps} from 'Quoting/components/shared/GridRow';
import {QuoteFormElement} from 'Quoting/components/shared/QuoteFormElement';
import React from 'react';
import {useSelector} from 'react-redux';
import {ReducerState} from 'rootReducer';
import {formatCurrencyValue} from './ACCBenefits';
import {deathandDismembermentPath} from './PropertyPaths/propertyPathACC';

export const GVA6AccidentalDismembermemt = () => {
  const {selectedPlan} = useSelector((state: ReducerState) => state.quoteForm);
  const {getQuoteFieldValue} = useQuoteField();
  const propertyPaths = deathandDismembermentPath(selectedPlan?.planIndex ?? 0);

  const situsStateCd = getQuoteFieldValue<string>('riskStateCd');

  const rows: GridRowProps[] = [
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-1'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.incurralPeriod,
          element: (
            <QuoteFormElement
              elementType="Text"
              type="number"
              label="Incurral Period (Days)"
              value={getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.incurralPeriod)}
              id={propertyPaths.accidentalDismembermentDetails.incurralPeriod}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.bothArmsOrHandsLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Both Arms or Hands"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.bothArmsOrHandsLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.bothArmsOrHandsLossAmount}
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-2'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.bothLegsOrFeetLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Both Legs or Feet"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.bothLegsOrFeetLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.bothLegsOrFeetLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of One Hand or Arm and One Leg or Foot"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.oneHandOrArmAndOneLegOrFootLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-3'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.armOrHandLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Arm or Hand"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.armOrHandLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.armOrHandLossAmount}
              adornment="money"
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.legOrFootLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Loss of Leg or Foot"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.legOrFootLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.legOrFootLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-4'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.oneOrMoreFingersLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={situsStateCd === 'NH' ? 'Loss of Finger(s)/Per Finger' : 'Loss of One or More Fingers'}
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.oneOrMoreFingersLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.oneOrMoreFingersLossAmount}
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.oneOrMoreToesLossAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label={situsStateCd === 'NH' ? 'Loss of Toe(s)/Per Toe' : 'Loss of One or More Toes'}
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.oneOrMoreToesLossAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.oneOrMoreToesLossAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-5'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.maximumBenefitAmount,
          element: (
            <QuoteFormElement
              elementType="Text"
              label="Maximum Benefit Amount"
              value={formatCurrencyValue(
                getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.maximumBenefitAmount)
              )}
              id={propertyPaths.accidentalDismembermentDetails.maximumBenefitAmount}
              required
              disabled
              adornment="money"
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
        {
          key: propertyPaths.accidentalDismembermentDetails.maxBenefitNumber,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="ACCAccidentalDismembermentBenefit.maxBenefitNumber"
              label="Number of Times Maximum Benefit is Payable per Time Period"
              value={getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.maxBenefitNumber)}
              id={propertyPaths.accidentalDismembermentDetails.maxBenefitNumber}
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
    {
      rowProps: {key: 'acc-death-dismemberment-accidentalDismemberment-row-6'},
      items: [
        {
          key: propertyPaths.accidentalDismembermentDetails.timePeriodCd,
          element: (
            <QuoteFormElement
              elementType="SelectV2"
              dropdownVariant="AttributeValue"
              searchKey="ACCAccidentalDismembermentBenefit.timePeriodCd"
              label="Time Period"
              value={getQuoteFieldValue(propertyPaths.accidentalDismembermentDetails.timePeriodCd)}
              id={propertyPaths.accidentalDismembermentDetails.timePeriodCd}
              required
              disabled
            />
          ),
          props: {xs: 12, sm: 6, md: 6},
        },
      ],
    },
  ];
  return <FormRowGrid rows={rows} />;
};
